import React, { Fragment, useState } from "react";

import { QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { Menu, Transition } from "@headlessui/react";
import { FiMenu, FiX } from "react-icons/fi";
import { Tooltip } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import useModal from "../../_layout/_partials/use-modal/useModal";
import ModalHelpEmail from "./modal-help-email/ModalHelpEmail";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const navigation = [
  {
    name: "Dashboard",
    href: "/page/dashboard-consorcio"
  }
];

const navigationMobile = [
  {
    name: "Dashboard",
    href: "/page/dashboard-consorcio"
  }
];

export default function Header() {
  const [navMobile, setNavMobile] = useState(false);

  const { open: openModalEmail } = useModal({
    component: ModalHelpEmail,
    modalHeader: (
      <div className="justify-start text-zinc-600 text-3xl font-bold">
        Como podemos ajudar?
      </div>
    ),
    showDivider: true,
    whitAnimation: true
  });

  return (
    <nav className="bg-menu" style={{ backgroundColor: "#0499b0" }}>
      <div className=" sticky w-full left-0 right-0 top-0 z-20 transition-all duration-500  max-w-7xl mx-auto py-4 px-2 sm:px-6 lg:px-8">
        {/* 0499b0 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <NavLink to="/" className="cursor-pointer">
              <img src="/images/logo/logo.svg" alt="Logo Acesso Energia" />
            </NavLink>
            <ul className="hidden lg:flex items-center gap-8">
              {navigation.map(item => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  activeStyle={{
                    backgroundColor: "#010130",
                    fontWeight: 700,
                    color: "#fff"
                  }}
                  className="px-3 py-2 rounded-md font-medium text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                >
                  {item.name}
                </NavLink>
              ))}
            </ul>
          </div>
          <div className="hidden lg:flex lg:gap-8">
            <div className="inset-y-0 right-0 items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 flex gap-3 px-3">
              <Tooltip title="Como podemos ajudar?" arrow placement="bottom">
                <button
                  className=""
                  type="button"
                  onClick={() => openModalEmail()}
                >
                  <QuestionMarkCircleIcon className="w-6 h-6 text-gray-100" />
                </button>
              </Tooltip>
              <Menu as="div" className="ml-3 relative">
                <div className="flex gap-5">
                  <div>
                    <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="h-8 w-8 rounded-full"
                        src="/images/usuario_avatar.svg"
                        alt=""
                      />
                    </Menu.Button>
                  </div>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="/page/conta"
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          Minha conta
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="/logout"
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          Logout
                        </a>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
          <div className="flex items-center gap-3 md:hidden">
            <div className="flex justify-end gap-2 inset-y-0 right-0 items-center">
              <Tooltip title="Como podemos ajudar?" arrow placement="bottom">
                <button
                  className=""
                  type="button"
                  onClick={() => openModalEmail()}
                >
                  <QuestionMarkCircleIcon className="w-6 h-6 text-gray-100" />
                </button>
              </Tooltip>
              <Menu as="div" className="ml-3 relative">
                <div>
                  <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-7 w-7 md:h-8 md:w-8 rounded-full"
                      src="/images/usuario_avatar.svg"
                      alt=""
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="/logout"
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          Meu perfil
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="/logout"
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          Logout
                        </a>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
            <div
              onClick={() => setNavMobile(!navMobile)}
              className="lg:hidden cursor-pointer "
            >
              {navMobile ? (
                <FiX className="text-3xl text-neutral-300 " />
              ) : (
                <FiMenu className="text-3xl text-neutral-300 " />
              )}
            </div>
          </div>
        </div>
        {navMobile ? (
          <div className="bg-black/10 border border-gray-600 p-5 rounded-lg lg:invisible w-full mt-3 ">
            <div className="flex items-center gap-3 w-full">
              <ul className="  flex flex-col gap-3 w-full">
                {navigationMobile.map(item => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    activeStyle={{
                      backgroundColor: "#010130",
                      fontWeight: 700,
                      color: "#fff"
                    }}
                    className="px-3 py-3 rounded-md font-medium text-sm text-gray-300 hover:bg-gray-700 hover:text-white w-full"
                  >
                    {item.name}
                  </NavLink>
                ))}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    </nav>
  );
}
